import $ from 'jquery';
import Action from 'actions';
import Const from 'constants';
import LineupShowDown from 'services/sports/mma/lineup/lineup-showdown';

export default class Lineup extends LineupShowDown {
    setPlayersByColumns({incomingValues: {team}}) {
        const {modesConfig} = Action.getState();
        const label = modesConfig.getConfig(Const.CAPTAIN_MODE).getLabel();

        let captain = null;
        let flex = [];
        team.map((player) => {
            if (player.getIsCaptain()) {
                captain = {...player, positionInLineup: label + ' - 1.5X Points'};
            } else {
                flex.push({...player, positionInLineup: 'FIGHTER'});
            }
        });

        return $.merge([captain], flex);
    }

    combineOptimizedAndNotExcludedPlayers({incomingValues: {optimizedPlayers, notExcludedPlayers, sportConfig}}) {
        return this.exec('combineOptimizedAndNotExcludedPlayersByLineupRole', {
            optimizedPlayers,
            notExcludedPlayers,
        });
    }
}
